import React from "react";
import { CommonIconButton } from "./common-styled";
import { AiFillHome } from "react-icons/ai";
import styled from "styled-components";
import { useSetAtom } from "jotai";

import { screenAtom } from "../jotai/service";
import { endStateAtom } from "../jotai/game";

const HomeButton = () => {
  const setScreen = useSetAtom(screenAtom);
  const setEndState = useSetAtom(endStateAtom);

  return (
    <CommonIconButton
      onClick={() => {
        setEndState(false);
        setScreen("Home");
      }}
    >
      <HomeIcon />
    </CommonIconButton>
  );
};

export default HomeButton;

const HomeIcon = styled(AiFillHome)`
  font-size: 35px;
`;
